import { render, staticRenderFns } from "./AzqProvider.vue?vue&type=template&id=f82d1750&lang=true&"
import script from "./AzqProvider.vue?vue&type=script&lang=js&"
export * from "./AzqProvider.vue?vue&type=script&lang=js&"
import style0 from "./AzqProvider.vue?vue&type=style&index=0&id=f82d1750&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports